import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router';

// Page Components:
import FavoriteButton from '../Buttons/FavoriteButton';

// MUI Component
import { Box,IconButton } from "@mui/material";
import MobileStepper from '@mui/material/MobileStepper';


// React Components:
import { useSwipeable } from 'react-swipeable';

// Styled comp:
import { styled } from '@mui/material/styles';

import { MdOutlineArrowBackIos,MdOutlineArrowForwardIos  } from "react-icons/md";


function Carousal({currObjID,favIconColor,currObjcetImages,oCustomStyle, sImageHight, onFavoriteClick, showMoreImages,showNavArrow}) {

 /*************************************************************
  * Style Definiton for Component
  ************************************************************/


    const ImageComp = styled(Box) ({
        width: '100%',
        height:'100%',
        objectFit:'contain'
    });

    const ImageHolder = styled(Box) ({
        width: '100%',
        height:'100%',
        position:'absolute',
        overflow:'hidden'

    });

    const FavIconCntnr =  styled(IconButton) ({
        width:'50px',
        textAlign:'center',
        position:'absolute',
        left:'3%',
        zIndex:1,
        height:'50px',
        top:'3%',
    });

    const ArrowButton =  styled(Box) ({
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        position: 'relative',
        top:'46%',
        backgroundColor: '#00000036',
        color:'white',
        borderRadius:'75%',
        border:'none',
        width: '30px',
        height:'30px',
        textAlign:'center',
        right:'10px'
    });

    const LeftArrow = styled(Box) ({
        width:'50px',
        textAlign:'center',
        backgroundColor:'transparent',
        position:'absolute',
        left:0,
        zIndex:1,
        transition: 'backgroundColor 0.5s',
        height:'30%',
        top:'50%',
        transform:'translateY(-50%)',
        borderTopRightRadius: '10px',
        borderBottomRightRadius:'10px',
        [`& ${ArrowButton}`]:{

        } 

    });

    const RightArrow = styled(Box) ({
        width:'50px',
        textAlign:'center',
        backgroundColor:'transparent',
        position:'absolute',
        left:'auto',
        right:0,
        zIndex:1,
        transition: 'backgroundColor 0.5s',
        height:'100%',
        top:'50%',
        transform:'translateY(-50%)',
        borderTopRightRadius: '10px',
        borderBottomRightRadius:'10px',
        [`& ${ArrowButton}`]:{

        } 
    });

    const StepperContainer =  styled(Box)({
        display: currObjcetImages.length > 1 ? 'flex' : 'none',
        justifyContent:'center'
        
    });

    const SlideShowContainer = styled(Box) ({
        width: '100%',
        // height:'100%',
        height:`${sImageHight}px`,
        overflow:'hidden',
        backgroundColor:'gainsboro',
        position:'relative',
        borderRadius:'7.5px 7.5px 0 0',
        zIndex:2,
        [`& ${ImageHolder}`]:{

        },
        [`& ${LeftArrow}`]:{

        },
        [`& ${RightArrow}`]:{

        }

    });

    const GaleryContainer =  styled(Box)({

        width: '100%',
        height:'100%',
        maxWidth:'1000px',
        userSelect:'none',
        boxSizing:'border-box',
        margin:'0 auto',
        [`& ${SlideShowContainer}`]: {

        }
    });


    // locale:
    oCustomStyle = {
        height:`${sImageHight}px`
    };

    // Stepper Component Style
   const oStepperStyle = {
        maxWidth:400,
        flexGrow: 1,
        position: 'absolute',
        zIndex:1,
        top: `${sImageHight - 30 }px`,
        backgroundColor: 'transparent'
        
    }


 /*************************************************************
  * SComponent Controller
  ************************************************************/

        const navigate = useNavigate();
        // const [images, setImage] = useState([currObjcetImages]); //not in use
        const [imageIndex, setImageIndex] = useState(0);

        const onNextImage = (event) => {
            setImageIndex(imageIndex + 1);

        }

        const onPrevImage = (event) => {
            setImageIndex(imageIndex - 1);

        }

        const handlers = useSwipeable({
            onSwiped: (eventData) => console.log("User Swiped!", eventData),
            onSwipedLeft: () => onPrevImage(),
            onSwipedRight: () => onNextImage(),
            swipeDuration: 300,
            preventScrollOnSwipe: true,
            delta: 100,
            trackMouse: true
        });

        const onGoToObject = () => {

        }



    return(
         <GaleryContainer {...handlers}>
             <SlideShowContainer>
                {/* <Box className="playPauseBtn" id="playPauseBtn"></Box> */}
                 {/* <Box className="leftArrow" onClick={onNextImage}><Box className="arrow arrowLeft"></Box></Box>
                 <Box className="rightArrow" ><Box className="arrow arrowRight"></Box></Box> */}
                 {/* <FavIconCntnr>
                    <FavoriteIcon
                        sx={{ color:favIconColor }} 
                        data-value={objID} 
                        onClick={ (oEvent) => onFavoriteClick(oEvent, objID)}/>
                </FavIconCntnr> */}
                <FavoriteButton currObjID={currObjID}></FavoriteButton>
                 <LeftArrow onClick={onNextImage} display={showMoreImages || showMoreImages === undefined & currObjcetImages.length > 1 ? 'block' : 'none'}>
                    <ArrowButton> 
                        <MdOutlineArrowBackIos/>
                    </ArrowButton>
                 </LeftArrow>
                 <RightArrow onClick={onPrevImage}  display={showMoreImages || showMoreImages === undefined & currObjcetImages.length > 1  ? 'block' : 'none'}>
                    <ArrowButton>
                        <MdOutlineArrowForwardIos/>
                    </ArrowButton>
                 </RightArrow>
                 {
                     currObjcetImages.map( (image, index) => { 
                         if (imageIndex < 0 || imageIndex >= currObjcetImages.length) {
                             setImageIndex(0);
                             return null;
                         } else if (imageIndex >= 0 && index === imageIndex) {
                            //  if (index === imageIndex) {
                                 return (
                                     <ImageHolder key={`img-${index}`} style={{ opacity: 1 }}>
                                         <Box 
                                            sx={{
                                                width: '100%',
                                                height:'100%' }}
                                                component='img'
                                                loading={ "lazy"}
                                                onClick={onGoToObject} src={image}></Box>

                                     </ImageHolder>
                                 )
                             } 
                             else {
                                 return (
                                     <ImageHolder key={`img-${index}`} style={{ opacity: 0  }}>
                                         <Box 
                                            sx={{
                                                // width: '-webkit-fill-available',
                                                width:'100%',
                                                height:'100%'
                                            }} 
                                            component='img' onClick={onGoToObject} src={image}></Box>

                                     </ImageHolder>
                                 )
                             }
                        //  }

                     })
                 }
                 <StepperContainer>
                        <MobileStepper
                          variant="dots"
                          steps={currObjcetImages.length}
                          position="static"
                          activeStep={imageIndex}
                          sx={oStepperStyle}
                          />
                </StepperContainer>    
                          
             </SlideShowContainer>
              
         </GaleryContainer> 

        

    )

}

export default Carousal;